export default "__VITE_ASSET__CS66Hh5l__"